import script from "./IdleView.vue?vue&type=script&setup=true&lang=js"
export * from "./IdleView.vue?vue&type=script&setup=true&lang=js"

import "./IdleView.vue?vue&type=style&index=0&id=d243d0c2&lang=css"

const __exports__ = script;

export default __exports__